import { render, staticRenderFns } from "./FiltroHistorico.vue?vue&type=template&id=69458f74"
import script from "./FiltroHistorico.vue?vue&type=script&lang=js"
export * from "./FiltroHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports